import type { Grant, LegalEntityRef, Permission, ShopRef, TenantRef } from '@serievo/contracts';
import { createContext, type ReactNode, useContext } from 'react';

/** Ngữ cảnh đang chọn trên thanh ngữ cảnh, dùng chung cho mọi trang. */
export interface Work {
  tenant: TenantRef;
  entity: LegalEntityRef;
  shop?: ShopRef;
  period: string;
  /** Tham số truy vấn chung cho API: entity, shop, period. */
  query: URLSearchParams;
  /** Quyền của người dùng trên công ty + pháp nhân đang chọn (API vẫn kiểm lại). */
  perms: Set<Permission>;
}

export function permsFor(grants: Grant[], tenantId: string, entityId: string): Set<Permission> {
  const out = new Set<Permission>();
  for (const g of grants) {
    if (g.tenantId !== tenantId || (g.legalEntityId !== null && g.legalEntityId !== entityId)) continue;
    for (const p of g.permissions) out.add(p);
  }
  return out;
}

const Ctx = createContext<Work | null>(null);

export function WorkProvider({ value, children }: { value: Work | null; children: ReactNode }) {
  return <Ctx.Provider value={value}>{children}</Ctx.Provider>;
}

/** Chỉ dùng trong trang nằm dưới AppShell (luôn có ngữ cảnh). */
export function useWork(): Work {
  const w = useContext(Ctx);
  if (!w) throw new Error('useWork: thiếu WorkProvider');
  return w;
}

export function buildQuery(entity: string, period: string, shop?: string, extra?: Record<string, string | undefined>) {
  const q = new URLSearchParams({ entity, period });
  if (shop) q.set('shop', shop);
  for (const [k, v] of Object.entries(extra ?? {})) if (v) q.set(k, v);
  return q;
}
